document.addEventListener("DOMContentLoaded", function () {
  let pdp_callbacks;
  let itemIdsWithDiscountApplication = [];
  fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((data) => {
      var kite_campaign = data.attributes.kite_campaign;
      let kite_campaig_code = kite_campaign ? kite_campaign.toLowerCase() : "";

      // Filter items with discount_application object available and return their IDs
      itemIdsWithDiscountApplication = data.items
        .filter((item) => {
          return item.line_level_discount_allocations.some((allocation) => {
            var discount_application = allocation.discount_application.title;
            let discount_application_code = discount_application.toLowerCase();

            return (
              allocation.discount_application.type != "discount_code" &&
              discount_application_code != kite_campaig_code
            );
          });
        })
        .map((item) => item.id);
    });

  // Select the target node
  const targetNode = document.querySelector("body");

    // Function to check freeGifts and Hide Remove icon in slide cart
    function checkAndUpdateFreeItems() {
      document.querySelectorAll('.hs-discount-price-total').forEach(el => {
        if (el.textContent.trim() === 'Free') {
          const parent = el.closest('.hs-item-cart-content');
          if (parent && !parent.classList.contains('has-free-item')) {
            parent.classList.add('has-free-item');
          }
        }
      });
    }



  // Create a new observer instance
  const observer = new MutationObserver(function (mutationsList, observer) {
    mutationsList.forEach(function (mutation) {
      // Check if class were modified
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        $('.hs-discount-price-total:contains("Free")')
          .closest(".hs-content-quantity-price")
          .find(".hs-item-cart-content-quantity")
          .hide();
        // Iterate over the array of item IDs
        itemIdsWithDiscountApplication.forEach((itemId) => {
          $(".hs-cls-discount .hs-item-" + itemId).hide();
          if (
            $(".pdp-page").length > 0 &&
            $('[value="' + itemId + '"]')
              .closest('[action="/cart/add"]')
              .find(".addto-cart-button").length > 0
          ) {
            $('[value="' + itemId + '"]')
              .closest('[action="/cart/add"]')
              .find(".qty-error")
              .remove();
            $(".pdp-sticky-footer-ctr").find(".qty-error").remove();
            $(".addto-cart-button").prop("disabled", false);
          }
        });
        checkAndUpdateFreeItems();

      }
    });
  });

  // Configuration of the observer
  const config = { attributes: true, subtree: true };
  // Start observing the target node for changes in attributes
  observer.observe(targetNode, config);

  var template = getScriptAttributes("template");
  var removed_free_gifts = [];
  //Avoid click add to cart before slidecart ready
  $(".addto-cart-button").addClass("button_or_link_disabled");

  $(document).on("keyup", ".hs-cart-plus-minus > input", function (event) {
    if (parseInt($(this).val()) > 2) {
      $(this).val("2");
      $(this).closest();
    }
  });

  // Slide cart fetch function /cart.js start
  window.HS_SLIDE_CART_LOADED = function (cart) {
    // It is executed once the cart has been loaded.
    initializePdpCallbacks(cart);
    custom_checkout_button_HS();
    $(".slide-cart-wait").removeClass("slide-cart-wait");
    $(".addto-cart-button").removeClass("button_or_link_disabled");

    if($.urlParam('hs_cart') && ($.urlParam('hs_cart')=="open")){
      $(".header__icon--cart")[0].click();
    }

  };

  function initializePdpCallbacks(cart) {
    if (
      $(".sas-page-kits-section").length <= 0 &&
      $(".prepurchase-page").length <= 0
    ) {
      pdp_callbacks = new PdpCallbacks(cart);
    }
  }

  window.HS_SLIDE_CART_UPDATED = function (cart) {
    $("a[name*='checkout']").removeAttr("href");
    initializePdpCallbacks(cart);
    if (
      pdp_callbacks != null &&
      pdp_callbacks.preupsell_link != "" &&
      pdp_callbacks.preupsell_link != undefined
    ) {
      $(".hs-checkout-purchase").attr("href", pdp_callbacks.preupsell_link);
    }
    set_free_gift_ui();
    $(".hs-item-cart-qty").removeAttr("style");

  };

  // Initial call to set up pdp_callbacks
  if (
    $(".sas-page-kits-section").length <= 0 &&
    $(".prepurchase-page").length <= 0
  ) {
    jQuery.getJSON("/cart.js?for=pdp_callback", function (cart) {
      initializePdpCallbacks(cart);
    });
  }
  // Slide cart fetch function /cart.js end
  window.HS_SLIDE_CART_LOADED = function (cart) {
    $(".slide-cart-wait").removeClass("slide-cart-wait");
    $(".addto-cart-button").removeClass("button_or_link_disabled");
    $(".hs-item-cart-qty").removeAttr("style");

      if($.urlParam('hs_cart') && ($.urlParam('hs_cart')=="open")){
        $(".header__icon--cart")[0].click();
      }
  };

  window.HS_SLIDE_CART_OPENED = function () {
    $(".hs-propertie-content").hide();
    $(".hs-content-propertie").hide();
    $(".hs-item-cart-qty").removeAttr("style");
    custom_checkout_button_HS();
    set_free_gift_ui();
    fetch("/cart.js?for=pdp_callback")
    .then((response) => response.json())
    .then((data) => {
    });
   
  };

function decodeHtml(html) {
  var txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}
window.HS_SLIDE_CART_UPSELL_ADD = function (id) {
  $(".hs-checkout-purchase").addClass("button_or_link_disabled");
  $(".hs-site-cart-popup-layout").addClass("hs-is-loading");
  fetch("/cart.js?for=cart_upsell_pricebook")
    .then((response) => response.json())
    .then((data) => {
      var campaign_pb = data;
      var cart_items = campaign_pb.items.filter(
        (obj) => obj.id == id
      );
      cart_items.map((item) => {
        var existing_properties = item.properties;
        var product_url = item.url;
        if (product_url) {
          var selling_plan_id = item.selling_plan_allocation?.selling_plan?.id || "";
          var items_id = item.id;
          var selling_plan_name = item.selling_plan_allocation?.selling_plan.name || "";
          var product_key = item.key;
          var quantity = item.quantity;
          // Check if the product_url is not empty
          var selling_plan_id_param = (selling_plan_id != null && selling_plan_id != "") ? "&selling_plan=" + selling_plan_id : "";
          var variant_id_param = (items_id != null && items_id != "") ? "&variant=" + items_id : "";
          jQuery.get(
            product_url + "&view=get_product_info_template&for=cart_upsell_pricebook" + selling_plan_id_param + variant_id_param,
            function (datap) {
              var pb_info = JSON.parse(datap);
              var product_from_PDP = "0";
              var giftproduct = (pb_info.free_gifts.length > 0) || (pb_info.default_free_gift > 0) || (pb_info.manual_free_gift > 0);
             
              if( selling_plan_id != undefined && selling_plan_id !="" && giftproduct ){
                var line_item_id = { "_line_item_id": items_id+":"+selling_plan_id+"-"+product_from_PDP};
              }else if( selling_plan_id == "" && giftproduct ){
                var line_item_id = { "_line_item_id": items_id+":"+product_from_PDP};
              }else{
                var line_item_id = {};
              }

              var allProperties = Object.assign({}, existing_properties, pricebook,line_item_id);

              var addfreegift = add_free_gift(allProperties._line_item_id,product_url,selling_plan_id,items_id,pb_info);

             
              if(item.selling_plan_allocation){
                if (pb_info.price_book != null && pb_info.price_book != "") {
                  var pricebook = { _pricebook: pb_info.price_book };
                } else {
                  var pricebook = {
                    _pricebook: campaign_pb.attributes.pricebook,
                  };
                }
              } else {
                var pricebook = {};
              }
              if (pb_info.pus_url != null && pb_info.pus_url != "") {
                var preupsell_properties = {
                  _product_from_PDP: "NOT_PDP",
                  _preupsell_link: pb_info.pus_url,
                  _preupsell_product_selling_plan: selling_plan_name,
                  _preupsell_variants: pb_info.pus_variants,
                  _preupsell_add_or_upgrade_cart: pb_info.pus_add_or_upgrade_cart,
                };
              } else {
                var preupsell_properties = {};
              }

              if (item.selling_plan_allocation) {
                var subscription_terms_content = decodeHtml(pb_info.subscription_terms);
                var subscription_terms = { _subscription_terms: subscription_terms_content };
              } else {
                var subscription_terms = {};
              }
              var giftproduct = (pb_info.free_gifts.length > 0) || (pb_info.default_free_gift > 0) || (pb_info.manual_free_gift > 0);
              
              if( selling_plan_id !="" && giftproduct ){
                var line_item_id = { "_line_item_id": items_id+":"+selling_plan_id+"-"+product_from_PDP};
              }else if( selling_plan_id =="" && giftproduct ){
                var line_item_id = { "_line_item_id": items_id+":"+product_from_PDP};
              }else{
                var line_item_id = {};
              }

              properties = {
                ...existing_properties, ...pricebook, ...preupsell_properties, ...subscription_terms, ...line_item_id
              };

              let formData = {
                properties: properties,
                id: product_key.toString(),
                quantity: quantity,
              };
              fetch(window.Shopify.routes.root + "cart/change.js?for=cart_upsell_pricebook", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
              })
                .then((data) => {


                  $(".hs-checkout-purchase").removeClass("button_or_link_disabled");
                  $(".hs-site-cart-popup-layout").removeClass("hs-is-loading");
                })
                .catch((error) => {
                  console.error("Fetch error:", error);
                  $(".hs-checkout-purchase").removeClass("button_or_link_disabled");
                  $(".hs-site-cart-popup-layout").removeClass("hs-is-loading");
                });

            });
        }
      });

    }).catch((error) => {
      console.error("Error fetching cart data:", error);
      $(".hs-checkout-purchase").removeClass("button_or_link_disabled");
      $(".hs-site-cart-popup-layout").removeClass("hs-is-loading");
    })
}

  function custom_checkout_button_HS() {
    const hs_checkout_button = document.getElementsByClassName(
      ".hs-checkout-purchase"
    );
    const custom_checkout_button = document.createElement("a");
    var attributes = $(".hs-checkout-purchase").prop("attributes");
    custom_checkout_button.innerHTML = $(".hs-checkout-purchase").html();
    $.each(attributes, function () {
      if (this.name != "type") {
        custom_checkout_button.setAttribute(this.name, this.value);
      }
    });

    if (pdp_callbacks.preupsell_link != null) {
      custom_checkout_button.setAttribute("href", pdp_callbacks.preupsell_link);
    }
    $(".hs-content-checkout-button").find("a.hs-checkout-purchase").remove();
    $(".hs-content-checkout-button").append(custom_checkout_button);
    $("button.hs-checkout-purchase").remove();
    if (pdp_callbacks.preupsell_link == null) {
      window.HS_SLIDE_CART_UPDATE(callback);
    }
  }

  function getScriptAttributes(name) {
    var scriptEls = document.getElementsByTagName("script");
    var found;
    Array.prototype.some.call(scriptEls, function (script) {
      if (script.attributes.name && script.attributes.name.value === name) {
        found = namedNodeMapToObject(script.attributes);
        return true;
      }
    });
    return found;
  }

  //set free gift UI in slide cart
  function set_free_gift_ui() {
    $(".hs-cart-content-price .hs-price-total").each(function (index) {
      var price_content = $(this).text().trim().toLowerCase();
      
      
      if (
        price_content == "free" ||
        price_content == "$0.00" ||
        price_content == "0.00" ||
        price_content == "0"
      ) {
        const custom_h6 = document.createElement("h6");
        const textNode = document.createTextNode(
          "Qty :" +
            $(this)
              .closest(".hs-content-quantity-price")
              .find(".hs-cart-plus-minus")
              .data("quantity")
        );

        custom_h6.appendChild(textNode);
         custom_h6.setAttribute(
          "class",
          "for_free"
        );
        custom_h6.setAttribute(
          "style",
          "font-size: 16px!important; position: absolute; "
        );

        $(this)
          .closest(".hs-content-quantity-price")
          .find(".hs-item-cart-content-quantity")
          .append(custom_h6);
        $(this)
          .closest(".hs-content-quantity-price")
          .find(".hs-item-cart-content-quantity")
          .find(":not(.for_free)")
          .hide();


          if($(this).closest(".hs-item-cart-description").find(".hs-content-selling-plan").length <= 0){
              $(this)
                .closest(".hs-item-cart-description")
                .find(".hs-item-close")
                .hide();
          }

      }
    });
  }
});


 
//add free gift
async function add_free_gift(qualifyUnicIDValue="",product_url="",selling_plan_id="",items_id="",pb_info={},cart_quantity=1) {
 $(".hs-checkout-purchase").addClass("button_or_link_disabled");

       try {
          // If pb_info is empty, fetch from URL
          if (Object.keys(pb_info).length === 0) {
            const params_avail = (!product_url.includes("?")) ? "?" : "&";
            const selling_plan_id_param = (!product_url.includes("selling_plan=")) ? "&selling_plan=" + selling_plan_id : "";
            const variant_id_param = (!product_url.includes("variant=")) ? "&variant=" + items_id : "";
            const url = product_url + params_avail + "view=get_product_info_template" + selling_plan_id_param + variant_id_param;

            const res = await fetch(url);
            const text = await res.text();
            pb_info = JSON.parse(text);
          }

          const giftproduct = (pb_info.free_gifts.length > 0) ? pb_info.free_gifts : pb_info.default_free_gift;

          if (!giftproduct || giftproduct.length === 0) return "";

          const freeGiftData = giftproduct.map(item => ({
            ...item,
            quantity:(cart_quantity*item.quantity),
            properties: {
              ...item.properties,
              _qualifying_line_item_id: qualifyUnicIDValue,
            }
          }));

          const formData = { items: freeGiftData };

            // Fire the request immediately and avoid blocking the main thread
            (async () => {
              try {
                const freegiftPromise = fetch("/cart/add.js?for=freegift", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify(formData),
                  cache: "no-store", // disable caching for real-time response
                  keepalive: true    // keeps the request alive even if page is navigating
                });

                // Don't block — parse JSON as soon as the response arrives
                const freegiftresponseData = await (await freegiftPromise).json();

                // Optional: do something with the response
                console.log("Free gift added fast:", freegiftresponseData);

              } catch (error) {
                console.error("Free gift add failed:", error);
              }
            })();
        
          $(".hs-checkout-purchase").removeClass("button_or_link_disabled");

          return "";

        } catch (error) {
          console.error("Error:", error);
          $(".hs-checkout-purchase").removeClass("button_or_link_disabled");
          return "";
        }

}

class PdpCallbacks {
  constructor(cart) {
    this.cart = cart;
    this.preupsell_link = "/checkout";
    this.line_item_key = "";
    this.product_list = "";
    this.selected_cart_key = this.higest_price_preupsell();
  }

  //Find higest price product for preupsell
  higest_price_preupsell() {
    var max_price = 0;
    var preupsellLink = "/checkout";
    var preupsellProduct = "";
    var preupsellVariant = [];
    var selectedProductCartKey = "";
    var preupsellProductSku = "";

    $("button[name*='checkout']").each(function (index) {
      $(this).prop("disabled", true);
    });

    //Filter all subcription products from cart
    let cart_data = [];

    let subcription_preupsell_link_enable = false;
    let gift_added = false;

    //check subcription products.
    $.each(this.cart.items, function (index, value) {
      if (
        value.selling_plan_allocation != null &&
        value.selling_plan_allocation != undefined &&
        max_price < value.final_price
      ) {
        if (
          value.properties != null &&
          value.properties._preupsell_link != "" &&
          value.properties._preupsell_link != undefined
        ) {
          subcription_preupsell_link_enable = true;
        }
        cart_data.push(value);
      }
    });

    //not have subcription products.
    if (cart_data.length <= 0 || !subcription_preupsell_link_enable) {
      var cart_items = this.cart.items.filter(
        (obj) =>
          obj.properties != null &&
          obj.properties._preupsell_link != undefined &&
          obj.properties._preupsell_link != ""
      );
      cart_data = cart_items;
    }

    $.each(cart_data, function (index, value) {
      if (
        value.properties != null &&
        value.properties._preupsell_link != undefined &&
        value.properties._preupsell_link != "" &&
        max_price < value.final_price
      ) {
        max_price = value.final_price;
        this.line_item_key = value.key;
        selectedProductCartKey = value.key;
        preupsellLink = value.properties._preupsell_link;
        preupsellProduct = value.properties._preupsell_product;
        if (value.properties._preupsell_variants) {
          preupsellVariant = JSON.stringify(
            value.properties._preupsell_variants
          );
        }
        preupsellProductSku = JSON.stringify(
          value.properties._preupsell_product_sku
        );
      }
    });

    this.selected_cart_key = selectedProductCartKey;
    if (preupsellVariant.length > 0) {
      var res = this.cart.items.filter((item) =>
        preupsellVariant.includes(item.id)
      );
      var res_tittle = cart_data.filter((item) =>
        preupsellVariant.includes(item.id)
      );
      if (res.length == 0) {
        this.preupsell_link = preupsellLink;
      } else {
        this.preupsell_link = "/checkout";
      }
    } else {
      var res = this.cart.items.filter(
        (item) => preupsellProduct == item.handle
      );
      if (res.length == 0) {
        this.preupsell_link = preupsellLink;
      } else {
        this.preupsell_link = "/checkout";
      }
    }

    const hs_checkout_button = document.getElementsByClassName(
      ".hs-checkout-purchase"
    );
    const custom_checkout_button = document.createElement("a");
    var attributes = $(".hs-checkout-purchase").prop("attributes");
    custom_checkout_button.innerHTML = $(".hs-checkout-purchase").html();
    $.each(attributes, function () {
      if (this.name != "type") {
        custom_checkout_button.setAttribute(this.name, this.value);
      }
    });
    if (this.preupsell_link != null) {
      custom_checkout_button.setAttribute("href", this.preupsell_link);
    }
    $(".hs-content-checkout-button").find("a.hs-checkout-purchase").remove();
    $(".hs-content-checkout-button").append(custom_checkout_button);
    $("button.hs-checkout-purchase").remove();
    if (this.preupsell_link == null) {
      window.HS_SLIDE_CART_UPDATE(callback);
    }

    $("button[name*='checkout']").each(function (index) {
      $(this).prop("disabled", false);
    });

    return this.selected_cart_key;
  }
  
}
